export const SETTINGS_TYPE = {
  PROFILE: 'profile',
  BUSINESS: 'business',
  TEAM: 'team',
  PAYMENT_METHOD: 'payment_method',
  INTEGRATION: 'integration'
};
